/**
 * The error codes of this area of the admin API and the auth routes (see
 * `./index.ts`). One entry per message the backend can send; the panel
 * translates `errors.<code>`.
 */
export const GAME_ERROR_CODES = [
  'AVAILABLE_TO_FILTER_NEEDS_TENANT_ID',
  'CONFIGURATION_HAS_NO_DRAFT_TO_DISCARD',
  'CONFIGURATION_HAS_NO_DRAFT_TO_PUBLISH',
  'CONFIGURATION_ID_NEVER_PUBLISHED',
  'CONFIGURATION_ID_NOT_PLATFORM_CONFIGURATION',
  'CONFIGURATION_NAME_TAKEN',
  'CONFIGURATION_SETTINGS_REQUIRED',
  'CONFIGURATION_STALE_DRAFT',
  'CONFIGURATION_STALE_VERSION',
  'COPY_OF_NEVER_PUBLISHED',
  'COPY_OF_NOT_A_CONFIGURATION',
  'DRAFT_EQUALS_CURRENT_VERSION',
  'ONLY_PLATFORM_ADMINS_MANAGE_GAMES',
  'PUBLISH_REFUSED',
  'SEED_OUTCOME_NEEDS_FREE_SPINS',
  'SEED_OUTCOME_NEEDS_GAMBLED_WIN',
  'SEED_SEARCH_NEEDS_PUBLISHED_VERSION',
  'SEED_SEARCH_TIMED_OUT',
  'SEED_SEARCHES_RUNNING',
  'SIMULATION_QUEUE_FULL',
  'SIMULATION_REFUSED',
  'TEST_CABINET_NEEDS_PUBLISHED_VERSION',
  'UNKNOWN_GAMES',
  'WEIGHT_SOLVE_REFUSED',
  'WEIGHT_SOLVE_TARGET_RTP_OUT_OF_RANGE',
  'WEIGHT_SOLVE_TIMED_OUT',
  'WEIGHT_SOLVES_RUNNING',
] as const
